import { Trans, useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, CardTitle, Drawer, Loading, Text } from '@reveni-io/reveni-ui'

import CarrierWithShippings from './CarrierWithShippings/CarrierWithShippings'
import OriginLocationSelector from './OriginLocationSelector/OriginLocationSelector'
import * as Styles from './styles'

const RequestPickupDrawer = ({
  show,
  onClose,
  loading,
  carriersToPickup,
  selectedCarriers,
  handleCheckCarrier,
  totalShipmentsCount,
  onSchedulePickups,
  loadingSchedulePickups,
  selectedLocationId,
  onChangeLocation,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Solicitar recogida')}</CardTitle>
      <Loading show={loading}>
        <Styles.Container>
          <OriginLocationSelector value={selectedLocationId} onChange={onChangeLocation} />
          {carriersToPickup?.length > 0 ? (
            <>
              <Text type="bodyMRegular">
                {totalShipmentsCount > 1 ? (
                  <Trans i18nKey="requestPickupsDrawerDescription" values={{ totalShipmentsCount }}>
                    <strong>{{ totalShipmentsCount }} envíos</strong> están listos y pueden programarse para su
                    recogida. Selecciona los transportistas con los que deseas solicitar una recogida.
                  </Trans>
                ) : (
                  <Trans i18nKey="requestPickupDrawerDescription" values={{ totalShipmentsCount }}>
                    <strong>{{ totalShipmentsCount }} envío</strong> está listo y puede programarse para su recogida.
                    Selecciona el transportista con el que deseas solicitar una recogida.
                  </Trans>
                )}
              </Text>
              {carriersToPickup?.map(carrier => (
                <CarrierWithShippings
                  key={carrier?.id}
                  carrier={carrier}
                  checked={selectedCarriers?.includes(carrier?.id)}
                  onCheck={handleCheckCarrier}
                />
              ))}
              <Styles.ActionButtonsContainer>
                <Button variant="outlined" onClick={onClose}>
                  {t('Cancelar')}
                </Button>
                <ButtonWithSpinner
                  defaultLabel={t('Solicitar recogida')}
                  onClick={onSchedulePickups}
                  loading={loadingSchedulePickups}
                  disabled={selectedCarriers?.length === 0 || loadingSchedulePickups}
                />
              </Styles.ActionButtonsContainer>
            </>
          ) : (
            <Styles.NoResultsFoundContainer>
              <img src="/logos/reveni_icon.svg" alt="Reveni Logo" width={100} />
              <Text type="titleM" color="#A1A1A1">
                {t('No hay envíos para solicitar una recogida')}
              </Text>
            </Styles.NoResultsFoundContainer>
          )}
        </Styles.Container>
      </Loading>
    </Drawer>
  )
}

export default RequestPickupDrawer
